import { createFileRoute, redirect } from '@tanstack/react-router'

/** RFC-231: the blocking setup interstitial is gone; chapter 0 of the Setup guide streams setup. */
export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/setup')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/guide',
      params: { workspaceId: params.workspaceId },
    })
  },
})
